module.exports = __webpack_public_path__ + "img/icon_top_cumulative_pre.df0c6800.png";